import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'aog-online-status',
  templateUrl: './online-status.component.html',
  styleUrls: ['./online-status.component.scss']
})
export class OnlineStatusComponent implements OnInit {
  @Input() onlineStatusMessage: string;
  @Input() onlineStatus: string;
  constructor() { }

  ngOnInit() {
    // if (this.onlineStatus == 'offline') {
    //   document.querySelector("body").classList.add("no_event");
    // }
    // if (this.onlineStatus == 'online') {
    //   document.querySelector("body").classList.remove("no_event");
    // }
  }

}
